import React, { useEffect, useMemo, useState } from "react";
import { Filter } from "../company/work-order/component/Filter";
import { FormattedMessage } from "react-intl";
import DropDown from "sr/helpers/ui-components/DropDown.tsx";
import { ReactDatePicker } from "sr/helpers/ui-components/ReactDatePicker";
import { Button } from "sr/helpers/ui-components/Button";
import { toast } from "react-toastify";

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export const TransactionDateFilter = (props) => {
    const today = useMemo(() => {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }, []);

    const availableMonths = useMemo(
      () => MONTHS.filter((_, idx) => idx <= today.getMonth()),
      [today]
    );

    const [selectedMonth, setSelectedMonth] = useState<string>("");
    const [from, setFrom] = useState<Date>(today);
    const [to, setTo] = useState<Date>(today);

    useEffect(() => {
      // Default to the current month.
      if (!selectedMonth) {
        const current = today.toLocaleString("en-US", { month: "short" });
        setSelectedMonth(current);
      }
    }, [selectedMonth, today]);

    useEffect(() => {
      if (!selectedMonth) return;

      const monthIndex = MONTHS.indexOf(selectedMonth);
      const start = new Date(today.getFullYear(), monthIndex, 1);
      const endOfMonth = new Date(today.getFullYear(), monthIndex + 1, 0);
      const clampedEnd = endOfMonth > today ? today : endOfMonth;

      setFrom(start);
      setTo(clampedEnd >= start ? clampedEnd : start);
    }, [selectedMonth, today]);

    const normalizeDate = (value: Date | string | null) => {
      if (!value) return null;
      const parsed = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(parsed.getTime())) return null;
      const normalized = new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
      return normalized > today ? today : normalized;
    };

    const handleFromChange = (value) => {
      const next = normalizeDate(value);
      if (!next) return;
      setFrom(next);
      if (to && next > to) {
        setTo(next);
      }
    };

    const handleToChange = (value) => {
      const next = normalizeDate(value);
      if (!next) return;
      if (from && next < from) {
        setTo(from);
        return;
      }
      setTo(next);
    };

    const handleApply = () => {
      if (!from || !to) {
        toast.error("Please select both From and To dates");
        return;
      }

      if (from > to) {
        toast.error("From date cannot be after To date");
        return;
      }

      if (from > today || to > today) {
        toast.error("Future dates are not allowed");
        return;
      }

      props?.setFrom(from);
      props?.setTo(to);
    };
  return (
    <Filter width="w-96" name={<FormattedMessage id="CLEANER.WALLET.BILLING.HISTORY.DATE.RANGE" defaultMessage='Date Range' /> } label={<FormattedMessage id="CLEANER.WALLET.BILLING.HISTORY.DATE.RANGE" defaultMessage='Date Range' /> }>
    <div className="px-3">
        <div className=" text-base ">Date Range</div>
    <DropDown value={selectedMonth} onChange={(e)=> setSelectedMonth(e.target.value)} dropdowndiv={'mt-5'} label = {<FormattedMessage id="CLEANER.WALLET.BILLING.HISTORY.MONTH.LABEL"></FormattedMessage>}>
    {availableMonths.map((month, index) => (
        <option value={month} key={index}>{month} {today.getFullYear()}</option>
    ))}
    </DropDown>
    <div className="flex justify-between space-x-5">
        <ReactDatePicker
          selected={from}
          onChange={handleFromChange}
          maxDate={to && to < today ? to : today}
          InputDivClass={'mt-5'}
          label={<FormattedMessage id="CLEANER.WALLET.BILLING.HISTORY.FROM"></FormattedMessage>}
        ></ReactDatePicker>
        <ReactDatePicker
          selected={to}
          onChange={handleToChange}
          minDate={from}
          maxDate={today}
          InputDivClass={'mt-5'}
          label={<FormattedMessage id="CLEANER.WALLET.BILLING.HISTORY.TO"></FormattedMessage>}
        ></ReactDatePicker>
    </div>
    </div>
    <div className="bg-gray-200 border-b my-2"></div>
    <div className="flex justify-end my-3">
    <Button onClick={handleApply} text={<FormattedMessage id="CLEANER.WALLET.DATE.RANGE.FILTER.APPLY" defaultMessage="Apply" />} className={'bg-[#ff39b3] font-bold text-white capitalize '} hoverbg={'bg-[#ff39b3] font-bold '}></Button>
       </div>
    </Filter>
);
};
